import React from 'react';
import { Col, Row } from '@paypalcorp/pp-react';
import KnowBefore from '../CustomizeKnowBefore';
import styles from './PageContent.module.less';
import CustomizeSection from '../CustomizePageSection';
import CustomizePageHeader from '../CustomizePageHeader';
import PageDescription from './PageDescription';

const CustomizePageContent = ({ ecmContent }) => {
  const { description, knowBeforeCards, content, pageHeader, additionalDescriptionContent } =
    ecmContent;
  return (
    <div className={styles.page_container}>
      <CustomizePageHeader ecmContent={pageHeader} />
      <Row id="setup-dev-environment" className={styles.row} noGutters>
        <Col
          xs={12}
          md={knowBeforeCards ? 8 : 12}
          className={styles.content_wrapper}
          key="page-content"
        >
          <PageDescription
            description={description}
            additionalDescriptionContent={additionalDescriptionContent}
          />
          {content.map((item, index) => (
            <CustomizeSection contentIndex={index + 1} ecmContent={item} key={item.id} />
          ))}
        </Col>
        {knowBeforeCards && (
          <Col xs={12} md={4} key="know-before-cards">
            <KnowBefore knowBeforeCards={knowBeforeCards} />
          </Col>
        )}
      </Row>
    </div>
  );
};

export default CustomizePageContent;
